const state = {
  distribuir_por_filial: localStorage.config_multifilial_distribuir_por_filial === 'S',
  considerar_estoque_grupo: localStorage.config_multifilial_considerar_estoque_grupo === 'S'
}

const getters = {
  get_distribuir_por_filial(state) {
    return state.distribuir_por_filial
  },
  get_considerar_estoque_grupo(state) {
    return state.distribuir_por_filial && state.considerar_estoque_grupo
  }
}

const mutations = {
  set_distribuir_por_filial(state, valor) {
    localStorage.config_multifilial_distribuir_por_filial = valor ? 'S' : 'N';
    state.distribuir_por_filial = valor
  },
  set_considerar_estoque_grupo(state, valor) {
    localStorage.config_multifilial_considerar_estoque_grupo = valor ? 'S' : 'N';
    state.considerar_estoque_grupo = valor
  }
}

const actions = {
  set_distribuir_por_filial: ({ commit }, valor) => {
    commit("set_distribuir_por_filial", valor)
  },
  set_considerar_estoque_grupo: ({ commit }, valor) => {
    commit("set_considerar_estoque_grupo", valor)
  }
}

export default { namespaced: true, state, mutations, getters, actions }
